import styled from "styled-components";
import { Button as ButtonMaterialUI } from "@material-ui/core";

export const Button = styled(ButtonMaterialUI)`
  width: 100%;
  background-color: #dcf8c6;
  display: block;
`;
